import { z } from 'zod';

export const ResellerStatusSchema = z.enum(['ACTIVE', 'PENDING', 'SUSPENDED']);
export type ResellerStatus = z.infer<typeof ResellerStatusSchema>;

export const ResellerAdminSchema = z.object({
  id: z.string(),
  partnerCode: z.string(),
  name: z.string(),
  email: z.string().email(),
  phone: z.string().nullable(),
  status: ResellerStatusSchema,
  maxDiscountPercent: z.number(),
  monthlyQuota: z.number().int().nullable(),
  bookingsThisMonth: z.number().int(),
  totalBookings: z.number().int(),
  totalCommission: z.string(),
  currentBalance: z.number(),
  apiKeysCount: z.number().int(),
  createdAt: z.string(),
  lastActivityAt: z.string().nullable(),
});
export type ResellerAdmin = z.infer<typeof ResellerAdminSchema>;

export const ResellerAdminBookingSummarySchema = z.object({
  id: z.string(),
  referenceNumber: z.string(),
  status: z.string(),
  amount: z.string(),
  commission: z.string(),
  visitDate: z.string(),
  createdAt: z.string(),
});
export type ResellerAdminBookingSummary = z.infer<typeof ResellerAdminBookingSummarySchema>;

export const ResellerListResponseSchema = z.object({
  resellers: z.array(ResellerAdminSchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  totalPages: z.number().int(),
});
export type ResellerListResponse = z.infer<typeof ResellerListResponseSchema>;

export const ResellerAdminBookingsResponseSchema = z.object({
  bookings: z.array(ResellerAdminBookingSummarySchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  totalPages: z.number().int(),
});
export type ResellerAdminBookingsResponse = z.infer<typeof ResellerAdminBookingsResponseSchema>;

export const ResellerListQuerySchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(100).optional(),
  status: ResellerStatusSchema.optional(),
  search: z.string().optional(),
});
export type ResellerListQuery = z.infer<typeof ResellerListQuerySchema>;

export const UpdateResellerSchema = z.object({
  maxDiscountPercent: z.number().min(0).max(50).optional(),
  monthlyQuota: z.number().int().min(0).nullable().optional(),
});
export type UpdateResellerInput = z.infer<typeof UpdateResellerSchema>;

export const ResellerGlobalConfigSchema = z.object({
  commissionRate: z.number().min(0).max(1),
  minDepositForDiscount: z.number().min(0),
});
export type ResellerGlobalConfig = z.infer<typeof ResellerGlobalConfigSchema>;
